import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BrandMark } from "@/shared/ui/core";
import { Button } from "@/shared/ui/core";

export interface FooterBrandColumnProps {
  /** Frase de misión bajo la marca. */
  mission: string;
  /** Texto del botón. */
  ctaLabel: string;
  ctaTo: string;
}

/**
 * Primera columna del pie: marca, misión corta y una sola llamada a la
 * acción. Ocupa dos columnas de la rejilla en escritorio, como en el
 * sistema actual: la misión necesita ancho para no partirse en ocho líneas.
 */
export function FooterBrandColumn({ mission, ctaLabel, ctaTo }: FooterBrandColumnProps) {
  const { t } = useTranslation();

  return (
    // El `col-span` vive en quien lo coloca en la rejilla (el pie lo
    // envuelve en su contenedor animado); aquí solo el aire a la derecha.
    <div className="lg:pr-10">
      {/* El imagotipo oficial, no el nombre compuesto a mano. */}
      <BrandMark height={34} />

      <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-ds-ink-3">
        {t(mission)}
      </p>

      <Button
        as={Link}
        to={ctaTo}
        variant="primary"
        size="sm"
        rightIcon={<ArrowRight />}
        className="mt-6"
      >
        {t(ctaLabel)}
      </Button>
    </div>
  );
}
